namespace Portico.Services {

    import pme = Portico.Models.Enterprise;
    import pmg = Portico.Models.Gateway;
    import psga = apigateway.client;
    import psgm = apigateway.models;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface IPatientService {
        get(patientId: string): angular.IPromise<pme.Patient>;
        save(patient: pme.Patient): angular.IPromise<pme.Patient>;
        search(patient: pme.Patient): angular.IPromise<pme.Patient[]>;
    }

    @Service('app', 'patientService')
	@Inject('$q', 'PatientV3Api')
    export class PatientService implements IPatientService {
        constructor(
            private $q: angular.IQService,
            private patientApi: psga.PatientV3Api
        ) { }

        get(patientId: string): angular.IPromise<pme.Patient> {
            // let patient = this.storageService.getItem<pme.Patient>(pm.StorageType.Session, `patient-${patientId}`);

            //if (patient) {
            //    patient = new pme.Patient(patient);
            //    this.storageService.saveItem<pme.Patient>(pm.StorageType.Session, `patient-${patientId}`, patient);
            //    return this.$q.when(patient);
            //}

			// TODO: wrap in an edge call
            return this.$q.when(this.patientApi.patientGetByTenantId(patientId).then((response) => {
                //patient = new pme.Patient(response);
                //this.storageService.saveItem<pme.Patient>(pm.StorageType.Session, `patient-${patientId}`, patient);
                //return patient;
                response.data.data.dateOfBirth = <moment.Moment><unknown>response.data.data.dateOfBirth?.toDate();
                return new pme.Patient(response.data.data);
            }));
        }

        save(patient: pme.Patient): angular.IPromise<pme.Patient> {
            const request: psgm.PatientSaveModel = {
                firstName: _.get(patient, 'firstName', ''),
                middleName: _.get(patient, 'middleName', ''),
                lastName: _.get(patient, 'lastName', ''),
                suffix: _.get(patient, 'suffix', ''),
                nickname: _.get(patient, 'nickName', ''),
                dateOfBirth: moment(_.get(patient, 'dateOfBirth', null)),
                gender: pmg.Gender[_.get(patient, 'gender', '')],
                // socialSecurityNumber: _.get(patient, 'ssn', ''),
                primaryLanguageId: _.toNumber(_.get(patient, 'primaryLanguageId', '')),
                isUsResident: _.get(patient, 'isUsResident', null),
                householdSize: _.get(patient, 'householdSize', null)
            };

            if (patient.id) {
				// TODO: wrap in an edge call
                return this.$q.when(this.patientApi.patientUpdateByTenantId(patient.id, request).then((response) => {
                    return new pme.Patient(response.data);
                }));
            } else {
				// TODO: wrap in an edge call
                return this.$q.when(this.patientApi.patientCreateByTenantId(request).then((response) => {
                    return new pme.Patient(response.data.data);
                }));
            }
        }

		search(patient: pme.Patient): angular.IPromise<pme.Patient[]> {
			const request: psgm.PatientSearchModel = {
				// maxRecordCount: null,
				firstName: _.get(patient, 'firstName', ''),
				lastName: _.get(patient, 'lastName', ''),
				// socialSecurityNumber: _.get(patient, 'ssn', ''),
				dateOfBirth: moment(_.get(patient, 'dateOfBirth', null)),
				addressOne: _.get(patient, 'addresses[0].address1', ''),
				city: _.get(patient, 'addresses[0].city', ''),
				state: _.get(patient, 'addresses[0].state', ''),
				zip: _.get(patient, 'addresses[0].zip', '')
			};

			// TODO: wrap in an edge call
            return this.$q.when(this.patientApi.patientSearchByTenantId(request).then((response) => {
				const temp: pme.Patient[] = [];

                for (const patient of response.data.data.patients) {
                    patient.dateOfBirth = <moment.Moment><unknown>patient.dateOfBirth?.toDate();
					temp.push(new pme.Patient(patient));
				}

				return temp;
			}));
		}
    }
}